<template>
  <section class="cont-exito">
    <div class="container">
      <div class="exito-head">
        <img src="@/assets/head-paso4.svg" />
        <i18n path="success.intro" tag="h1">
          <b v-if="this.$store.state.gender === 1">{{ this.$i18n.t("success.introMale") }}</b>
          <b v-else>{{ this.$i18n.t("success.introFemale") }}</b>
          <b>{{ name }}</b>
        </i18n>
      </div>

      <div class="exito-bienvenida">
        <div class="exito-bienvenida__foot">
          <i18n path="success.emailSent" tag="h3">
            <b>{{ email }}</b>
          </i18n>
          <br />
          <v-row no-gutters v-if="getWebsite">
            <v-spacer />
            <v-btn class="btn-finish" color="primary" rounded @click="redirectButton()">Continuar</v-btn>
            <v-spacer />
          </v-row>
          <p v-else>{{ this.$i18n.t("success.continue") }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable arrow-parens, global-require, no-restricted-globals */
export default {
  name: "Success",
  data() {
    return {
      valid: false,
      savingDialog: false,
      errorMessage: this.$i18n.t("errors.resendEmail"),
      errorDialog: false,
      successMessage: this.$i18n.t("success.success"),
      successDialog: false,
      email: this.$store.state.email ? this.$store.state.email : null,
      name: this.$store.state.name ? this.$store.state.name : null,
      sendEmail: null,
      loading: false,
      alertMessage: null,
      emailRules: [
        v => !!v || this.$i18n.t("forms.formMustComplete"),
        v =>
          // eslint-disable-next-line implicit-arrow-linebreak
          /^\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/.test(v) || this.$i18n.t("forms.formEmail"),
      ],
    };
  },
  computed: {
    getWebsite() {
      if (location.href.includes("relif") || location.href.includes("brolly")) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async resendEmail() {
      this.loading = true;
      this.savingDialog = true;
      try {
        const response = await this.axios.post(
          `${process.env.VUE_APP_BACKEND}resend`,
          {
            email: this.email.trim(),
            sendEmail: this.sendEmail.trim(),
          },
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
            },
          },
        );
        this.savingDialog = false;
        this.loading = false;
        if (response.data.code !== 200) {
          this.errorDialog = true;
          return;
        }
        this.successDialog = true;
      } catch {
        this.savingDialog = false;
        this.errorDialog = true;
        this.loading = false;
      }
    },
    redirectButton() {
      if (location.href.includes("brolly")) {
        window.location.href = this.$i18n.t("success.redirect.brolly", { email: this.$store.state.email });
      } else if (location.href.includes("relif")) {
        window.location.href = this.$i18n.t("success.redirect.relif");
      } else {
        window.location.href = this.$i18n.t("success.redirect.ameris");
      }
    },
  },
};
</script>

<style scoped>
.succcess-text {
  color: white !important;
}
</style>
